import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { fmtDate } from "../SuperHeader";
import { useAdminFetch, TabState } from "../useAdminFetch";

const METRICS = ["recipients", "sent", "delivered", "read", "failed", "replies"];

export default function CampaignsTab({ cid }) {
  const { data, error, loading } = useAdminFetch(`/admin/companies/${cid}/campaigns`);
  return (
    <Card className="p-4 border-slate-200" data-testid="campaigns-tab">
      <TabState loading={loading} error={error} empty={data?.length === 0} emptyText="No campaigns yet." testid="campaigns">
        <div className="overflow-x-auto">
          <table className="w-full text-sm min-w-[760px]">
            <thead className="bg-slate-50 text-xs uppercase text-slate-600"><tr><th className="p-2 text-left">Campaign</th><th className="p-2 text-left">Status</th>{METRICS.map((m) => <th key={m} className="p-2 text-center">{m}</th>)}</tr></thead>
            <tbody>{(data || []).map((c) => (
              <tr key={c.id} className="border-t border-slate-100" data-testid={`campaign-row-${c.id}`}>
                <td className="p-2">{c.name}<div className="text-[11px] text-slate-500">{fmtDate(c.created_at)}</div></td>
                <td className="p-2"><Badge variant="outline">{c.status}</Badge>{c.paused_reason === "company_suspended" && <div className="text-[10px] text-rose-600">paused by suspension</div>}</td>
                {METRICS.map((m) => <td key={m} className="p-2 text-center">{c.metrics?.[m] ?? "—"}</td>)}
              </tr>))}</tbody>
          </table>
        </div>
      </TabState>
    </Card>
  );
}
